import { SocketConnectionWorker } from '../../../components/SocketConnection';
import { EVENT_USER_DRIVERS } from '../../../components/SocketConnection/constants';
import { getUserId } from '../../../Services/UserService';
import { DriverOption } from '../DriverState';

export const setDriverIdsToSocketServerEffect =
  () =>
  ({ onSet }): void => {
    onSet((newValue: DriverOption[]) => {
      const data = {
        event: EVENT_USER_DRIVERS,
        payload: newValue.map((item: DriverOption) => item.value),
        userId: getUserId(),
      };
      // console.log('setDriversToSocketServerEffect', data);
      SocketConnectionWorker.postMessage(data);
    });
  };

export default setDriverIdsToSocketServerEffect;
